import moment from "moment";

export default class OrderCheckout {
    constructor(data) {
        // 目前沒有 linePay or 刷卡 checkoutTime 填 null
        if (data.payment.paymentType === 'linePay') {
            this.checkoutTime = moment().utc().format()
        } else {
            this.checkoutTime = null
        }
        if (data.payment.paymentType === 'linePay') {
            this.payment = data.payment.paymentPrice
        } else {
            this.payment = 0
        }
        this.stagedTime = moment().utc().format(),
        this.store = data.store_code || null,
        // randomNumber 需改為使用random 亂數產生 0000 ~ 9999
        // 並以4碼數字字串表示
        this.randomNumber = (Math.floor(Math.random() * 9999)).toString().padStart(4, '0'),
        this.sellerTaxID = null,
        this.invoiceNumber = data.payment.invoiceType.type === '手機載具' ? data.payment.invoiceType.invoiceNumber : null,
        this.isTestSiteInvoice = null,
        this.buyerTaxID = null,
        this.eInvoiceBarCode = null,
        this.npoCode = null,
        this.note = data.payment.comment || null,
        this.paymentType = data.payment.paymentType,
        this.paymentExtra = null,
        this.eventDiscount = null,
        this.onSiteDiscount = null,
        this.extraFee = null,
        this.taxFreeOnSiteDiscount = null,
        this.pointDiscount = data.payment.pointQuantity,
        this.discountRate = null,
        this.hiddenCost = null,
        this.status = null,
        this.statusNote = null,
        this.abandonRequester = null,
        this.checkoutStaff = null,
        this.refunder = null,
        this.refundStaff = null,
        this.storeMemberUUID = data.store_member_uuid || null,
        this.pointIncrease = null,
        this.pointDecrease = null,
        this.vipLevel = data.vipLevel || 1,
        //Add By Bryant 2025/08/22 Begin
        this.userMobileTail = data.payment.userMobileTail || null,
        //Add By Bryant 2025/08/22 End
        this.storeServiceFeeSetting = new ServiceFeeSetting(data.storeServiceFeeSetting)
    }
}

class ServiceFeeSetting {
    constructor(data) {
        this.serviceFeeCalc = data.serviceFeeMode,
        this.fromOriginalRate = data.serviceFeeRate,
        this.afterDiscountRate = data.serviceFeeRate
    }   
}